<!--
 * @Author: Merlin
 * @Date: 2025-01-22 18:33:17
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-27 15:31:44
 * @Description: 
因为当前游戏在收到输赢结果后可以“立即” 呈现
经查验，原版游戏也是“立即” 显示扣款的， 
基于以上，现在关闭以下方法，于 2025.03.10 14:49:53 星期一 
.showDateInQueue()
.queueForward()
-->

<template>
    <NuxtLayout name="casino">
        <div class="tower-game">
            <ClientOnly>
                <GameSettingsDiceTabsWrapper class="flex !justify-end !mb-3">
                    <GameSettingsButtonLiveChat
                        v-if="useUserStore().isLoggedIn"
                        v-model="isOpenLiveChat"
                    />
                    <GameSettingsButtonAnimate v-model="settingStore.animation" />
                    <GameSettingsButtonFast v-model="game.tower.fast" gameName="tower" />
                    <GameSettingsButtonFairness v-model="isOpenFairness" />
                    <GameSettingsButtonRule v-model="isOpenRule" name="tower" />
                    <GameSettingsButtonVocie
                        v-model="settingStore.inhouseGames.sound.on"
                        v-model:voice-model-value="settingStore.inhouseGames.sound.music"
                        :saveAfterChange="true"
                    >
                    </GameSettingsButtonVocie>
                </GameSettingsDiceTabsWrapper>
            </ClientOnly>
            <!-- 
                ↑ 顶部控制条
                ↓ 游戏区
            -->
            <div class="p-[20px_20px_20px_220px] sm:p-3 rounded-md relative tower-container">
                <ClientOnly>
                    <Board
                        :currentMutiplier="coefficients.numberDevilkins"
                        :is-auto="game.tower.auto.default"
                        v-model:round="coefficients.round"
                        :is-submiting="oForm.isSubmiting"
                        v-model:saved-predictions="coefficients.savedPredictions"
                        :sounds="musicControler"
                        :animateEnabled="settingStore.animation"
                        v-model:fields="coefficients.fields"
                        v-model:isOpenResult="isOpenResult"
                        v-model:predictionSending="predictionSending"
                        @reset="reset"
                        :mutiConfig="mutiConfig"
                        :multiInfoShowDuration="multiInfoShowDuration"
                    />
                    <Result
                        :is-open="isOpenResult"
                        :expected-reward="expectedReward"
                        :mutipl="coefficients.round.multi"
                    />
                </ClientOnly>
            </div>
            <!-- 
                ↑ 游戏舞台
                ↓ 下注表单区 
            -->
            <ClientOnly>
                <CasinoBetOptionSection
                    :betTookit="betTookit"
                    :auto-bet-tool-kit="autoBetToolKit"
                    v-model:bet-amount-modal-value="oForm.amount"
                    v-model:is-submiting="oForm.isSubmiting"
                    :sound="settingStore.globalSounds"
                    :isAuto="game.tower.auto.default"
                    :bet-submit="isCashOutable ? cashOut : betSubmit"
                    :is-fast="game.tower.fast"
                    :amount-disabled="isDisabledAmountBtn"
                    :disabledSwitch="disabledSwitch"
                    :expected-reward="
                        [GameStatus.PLAY, GameStatus.CASHOUT].includes(coefficients.round.status)
                            ? expectedReward
                            : 0
                    "
                    :normalBtnLable="
                        [GameStatus.PLAY, GameStatus.CASHOUT].includes(coefficients.round.status) &&
                        coefficients.round.step !== 10
                            ? t.CashOut
                            : ''
                    "
                    :normalBtnDisabled="isDisabledNormalBtn"
                    :autoBtnDisabled="isAutoNoPicked"
                    @change-mode="toChangeMode"
                    :coefficients="coefficients"
                />

                <LevelOption
                    v-model:numberDevilkins="coefficients.numberDevilkins"
                    v-model:win-amount="coefficients.round.winAmount"
                    v-model:round="coefficients.round"
                    v-model:fields="coefficients.fields"
                    :is-auto="game.tower.auto.default"
                    :bet="EMIT_TOWER_BET"
                    :sounds="musicControler"
                    :disabled="isDisabledAmountBtn"
                    v-model:savedPredictions="coefficients.savedPredictions"
                    :is-submiting="oForm.isSubmiting"
                    v-model:isOpenResult="isOpenResult"
                    @reset="reset"
                    :coefficients="coefficients"
                    :animateEnabled="settingStore.animation"
                    v-model:predictionSending="predictionSending"
                />
                <!-- ↓ 自动模式的设定窗口（表单） --> 
                <CasinoAutoSection
                    v-model:amount="oForm.amount"
                    :ref="(el) => (oAutoDialog = el)"
                    :is-fast="game.tower.fast"
                    :is-submiting="isDisabledAmountBtn || oForm.isSubmiting"
                    :is-auto="game.tower.auto.default"
                />
            </ClientOnly>
            <!-- <article v-if="tempTest">
                <button @click="fnTestToTop(0)">
                    开始爬山
                </button>
            </article> -->
        </div>
    </NuxtLayout>
</template>

<script setup lang="ts">
import { Notify } from 'quasar';
import useTranslation from '~/i18n/useTransLation';
// stores
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { useUserStore } from '~/stores/user';
import useSettingsStore from '~/stores/settings';
// socket
import { useGameSocket } from '~/socket/game';
// components
import Board from './_components/Board.vue';
import LevelOption from './_components/LevelOption.vue';
import Result from './_components/Result.vue';
// functions
import { useAutoBetToolKit } from '~/common/js/bettingToolkit/auto';
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import { BetType, GameStatus, type RoundStatus } from './data';
import { showTips4BadAmountIfNeeded } from '~/common/js/betHelper';
// assets
import winSound from '~/assets/mp3/win.mp3';
import simpleClickSound from '~/assets/mp3/simple_click.mp3';
import towerBGM from '~/assets/mp3/game_general_bgm.mp3';
import losingSound from '~/assets/mp3/losing.mp3';
import {mutiConfigObj} from '@/pages/casino/towerGame/data/index';

const settingStore = useSettingsStore();
const t = useTranslation();
const { EMIT_TOWER_BET } = useGameSocket();
const isOpenFairness = ref(false);
const isOpenRule = ref(false);
const isOpenLiveChat = ref(false);
const isOpenResult = ref(false);
const { game } = storeToRefs(settingStore);
const joinStateStore = useJoinStateStore();

const oForm = reactive({
    amount: 1,
    isSubmiting: false,
});

let coefficients = ref({
    currentMutiplier: 1,
    numberDevilkins: 2,
    savedPredictions: [],
    // 未完成的游戏
    round: {
        prediction: [],
        status: '',
        difficulty: 2,
        level: 0,
        multi: 0,
        step: game.value.tower.auto.default ? 0 : -1, // 不准，以 onMounted() 内另有赋值 
        rounds: null,
        winAmount: 0,
        win: false,
        hash: '',
    } as RoundStatus,
    fields: null as number[][],
    lastRound: null,
    roundAnimationTime: 500,
    isResult: false,
    roundTime: 0,
    insertDelay: 200, // 数据插入延迟时间
});
const oMusicLib = {
    bg: {
        src: towerBGM,
        loop: true,
        isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
    },
    win: {
        src: winSound,
    },
    simpleClick: {
        src: simpleClickSound,
    },
    lose: {
        src: losingSound,
    },
};
let musicControler = null;

const betTookit = useBettingToolkit(oForm);
const multiInfoShowDuration = 2_000; // 倍数信息显示时长 
const predictionSending = ref(false); // true 表示已经提交了预测值 xx 毫秒后将切为 false 表示提交完毕 
// 恢复上局时切换为手动模式，需跳过模式 watch 的 reset，避免覆盖刚恢复的状态
const skipModeReset = ref(false);

const mutiConfig = reactive(
    deepCopy(mutiConfigObj)
);

// ↓ 登山套件（用于测试）
const tempTest = Date.now() < new Date('2025-05-31 23:59:59').getTime(); 
// if (import.meta.dev && import.meta.client) {
//     window['fnTestToTop'] = fnTestToTop;
// }
async function fnTestToTop(iDelay=0){
    console.log('fnTestToTop');
    game.value.tower.auto.default = false; // 设为手动，
    await Sleep(iDelay);
    if (
        joinStateStore.lastRound?.winAmount 
        || !tempTest
    ) return;
    coefficients.value.numberDevilkins = 1;
    oForm.amount = 2 + Math.random() * 20;
    await fnDoManulBet();
    const boardIndex = 1;
    for (const idx of Array(9).keys()){
        await (window as any).scheduler.yield();
        await Sleep(200);
        const res = await EMIT_TOWER_BET({
            prediction: boardIndex,
            isFast: false,
            type: BetType.HandsStart,
            frontID: Date.now(),
        }) as any;
        // console.log('当前楼层：', res.fields.length, '↓\n', deepCopy(res)); 
        if (!res.win){
            return setTimeout(()=>fnTestToTop(0), 100);
        }
        const oRound = coefficients.value.round;
        coefficients.value.fields = res.fields;
        coefficients.value.round = ({
            ...oRound,
            ...res,
            step: oRound.step + 1, 
            status: res.status ? res.status : 'cashout',
            prediction: [...oRound.prediction, boardIndex],
        });
    }
};


// 用于禁止模式变更 
const disabledSwitch = computed(()=>{
    // ↓ 任一为真需要禁用  
    return oForm.isSubmiting || joinStateStore.gameRunning;
});

const autoMode = async (fields) => {
    // Reset round level and prediction
    coefficients.value.round.level = null;
    coefficients.value.round.prediction = [];

    // Iterate over saved prediction
    for (let i = 0; i < coefficients.value.savedPredictions.length; i++) {
        coefficients.value.round.level = i;
        await coefficients.value.fields.push(fields[i]);
        await coefficients.value.round.prediction.push(coefficients.value.savedPredictions[i]);
        // Check if prediction matches field
        if (fields[i].includes(coefficients.value.savedPredictions[i])) {
            coefficients.value.round.level = 10;
            coefficients.value.round.status = GameStatus.LOSE;
            musicControler?.oAudio.lose.toPlay();
            return;
        }

        // If not in fast mode, play sound and wait
        if (!game.value.tower.fast && settingStore.animation) {
            musicControler?.oAudio.simpleClick.toPlay();
            await Sleep(coefficients.value.roundAnimationTime);
        }
    }
    isOpenResult.value = true;
    musicControler?.oAudio.win.toPlay();
};

// ↓ 自动模式输入面板“窗口化改造” 添加的变量与方法：
const oAutoDialog = ref(null);
const toChangeMode = (isAuto) => {
    if (
        !settingStore.game.tower.auto.default &&
        [GameStatus.PLAY, GameStatus.CASHOUT].includes(coefficients.value.round.status)
    ) {
        return;
    }
    const hasChanged = !!settingStore.game.tower.auto.default != !!isAuto;
    settingStore.game.tower.auto.default = !!isAuto;
    settingStore.game.tower.fast = !!isAuto;
    if (hasChanged){
        coefficients.value.savedPredictions = [];
        reset();
    }
    if (isAuto) {
        oAutoDialog.value.switchAutoDialogVisible(true);
    }
};

/**
 * 获取预测值，已选择保存的集合中是否包含devil
 * @param savedPredictions 已选择保存的集合
 * @param fields 所有devil集合
 * @return devil在savedPredictions中的索引
 */
const getRoundTime = (savedPredictions, fields) => {
    coefficients.value.roundTime += coefficients.value.roundAnimationTime;

    return savedPredictions.findIndex(
        (item, index) => fields[index] && fields[index].includes(item),
    );
};

/**
 * 状态重置
 */
const reset = () => {
    console.log('reset() excuted'); 
    if (0 && import.meta.dev){
        console.trace();
    }
    coefficients.value.round.level = game.value.tower.auto.default ? 1 : null;
    coefficients.value.round.step =  game.value.tower.auto.default ? 0 : -1;
    coefficients.value.round.win = false;
    coefficients.value.round.winAmount = 0;
    coefficients.value.fields = [];
    coefficients.value.round.prediction = [];
    joinStateStore.gameRunning = false;
    coefficients.value.round.status = GameStatus.EMPTY; 
};

/**
 * 返现，手工返现 
 */
const cashOut = async () => {
    if (predictionSending.value) {
        return console.log('提现操作被拦截；因为上次点击未完成');
    }
    predictionSending.value = true; // 上锁，返现期间不能点击舞台 
    try {
        const res = await EMIT_TOWER_BET({
            type: BetType.CashOut,
            isFast: false,
            frontID: new Date().getTime(),
        });
        predictionSending.value = false;
        isOpenResult.value = true;
        coefficients.value.round.status = res.win ? GameStatus.WIN : GameStatus.LOSE;
        coefficients.value.fields = res.fields;
        coefficients.value.round.multi = res.multi;
        coefficients.value.round.winAmount = res.winAmount;
        coefficients.value.round.win = res.win;
        musicControler?.oAudio.win.toPlay();
        await Sleep(coefficients.value.insertDelay);
        // joinStateStore.showDateInQueue(); // 插入游戏结果并播放动画
        joinStateStore.gameRunning = false;
    } catch (error) {
        console.error(error);
    }
};

/**
 * 点击下注（2种下注模式的入口方法）
 */
const betSubmit = async () => {
    isOpenResult.value = false;
    const $t = useNuxtApp().$i18n.t;
    // console.log('auto.default =', game.value.tower.auto.default);
    coefficients.value.fields = [];
    coefficients.value.round.prediction = [];
    joinStateStore.gameRunning = true;
    const isAuto = Boolean(game.value.tower.auto.default); 
    // ↓ 手动模式 
    if (isAuto == false) {
        fnDoManulBet();
        return;
    }
    // ↓ 自动模式 
    try {
        const payload = {
            amount: getFixed(oForm.amount), 
            prediction: coefficients.value.savedPredictions,
            difficulty: coefficients.value.numberDevilkins,
            isFast: true,
            type: BetType.HandsStart,
            frontID: Date.now(),
        };
        // if (import.meta.env.DEV_MODE && Math.random() <= 0.2){ 
        //     payload.amount = '0'; 
        // }
        // useUserStore().queueStart(); // 防止余额立即变化 
        const res = (await EMIT_TOWER_BET(payload as any)) as any;
        if (!res || res.error || res.code) {
            reset();
            return res;
        }
        console.log('tower bet 01 ↓\n', deepCopy(res)); 
        // reset round level and prediction
        coefficients.value.round.level = 0;
        getRoundTime(coefficients.value.savedPredictions, res.fields);
        await Sleep(250);
        await autoMode(res.fields);
        // joinStateStore.showDateInQueue(); // 插入游戏结果并播放动画
        // useUserStore().queueForward(); // 显示余额变化
        coefficients.value.fields = res.fields;
        coefficients.value.round = {
            ...coefficients.value.round,
            ...res,
            status: !res.win || res.status === 'lose' ? GameStatus.LOSE : (res.status || GameStatus.CASHOUT),
        };
        if (isAuto) {
            await Sleep(750);
        }
        return {
            amount: getFixed(oForm.amount),
            ...res,
        };
    } catch (err) {
        console.error(err);
        reset();
        coefficients.value.round.status = GameStatus.PLAY;
        coefficients.value.round.level = 1;
        // this.autobetsStop();
    } finally {
    }
};

// 手动投注 
const fnDoManulBet = async ()=> {
    reset();
    joinStateStore.gameRunning = true;
    try {
        coefficients.value.round.status = GameStatus.PLAY;
        coefficients.value.round.level = 1;
        // if (import.meta.env.DEV_MODE && Math.random() < 0.3){ 
        //     oForm.amount = 0; 
        // }
        const res = (await EMIT_TOWER_BET({
            amount: getFixed(oForm.amount),
            difficulty: coefficients.value.numberDevilkins,
            isFast: false,
            type: BetType.StartBet,
            frontID: new Date().getTime(),
        })) as any;
        console.log('tower bet 02 ↓\n', deepCopy(res)); 
        if (!res || res?.code) {
            showNegativeNotify(res?.error);
            reset();
            return;
        }
        coefficients.value.round.step = 0;
    } catch (err) {
        console.error(err);
        reset();
    }
};

const autoBetToolKit = useAutoBetToolKit(oForm, betSubmit as any);

// ↓ 禁用 amount 输入框 
const isDisabledAmountBtn = computed(() => {
    const fields = coefficients.value.fields;
    if (fields && fields.length === 10) {
        return false;
    }
    const bResult = [
        GameStatus.PLAY,
        GameStatus.CASHOUT,
    ].includes(coefficients.value.round.status);
    // console.log('isDisabledAmountBtn =', bResult); 
    return bResult;
});

/**
 * 判断当前按钮状态是下注还是返现
 */
const isCashOutable = computed(() => {
    return (
        coefficients.value.round.status === GameStatus.CASHOUT &&
        coefficients.value.round.step !== 10
    );
});

/**
 * 控制下注按钮禁用状态
 */
const isDisabledNormalBtn = computed(() => {
    const fields = coefficients.value.fields;
    if (fields && fields.length === 10) {
        return false;
    }
    if (isCashOutable.value) return false;
    return [GameStatus.PLAY].includes(coefficients.value.round.status);
});

/**
 * 控制自动下注按钮状态
 */
const isAutoNoPicked = computed(() => {
    if (game.value.tower.auto.default) {
        return coefficients.value.savedPredictions.length === 0;
    }
});

/**
 * 返现金额
 */
const expectedReward = computed(() => {
    const { winAmount } = coefficients.value.round;
    return winAmount;
});

watch(
    () => settingStore.inhouseGames.sound.on,
    (newVal) => {
        if (import.meta.server) return; 
        if (newVal && !musicControler) {
            musicControler = new MusicControler(oMusicLib);
            console.log('♪ 音频包已加载');
        }else{
            console.log('♪ 音频包没有被加载 ✘');
        }
    },
    {
        immediate: true,
    },
);

// 关闭下注结果弹框
watch(isOpenResult, (value) => {
    if (value) {
        console.log('Closeclosure will begin in', multiInfoShowDuration, 'ms');
        setTimeout(() => {
            isOpenResult.value = false;
            console.log('Closeclosure finished');
        }, multiInfoShowDuration);
    }
});

watch(
    () => [game.value.tower.auto.default, settingStore.pickedCurrency],
    (value, oldValue) => {
        if (skipModeReset.value) return;
        // 首次 immediate 仅初始化 step，避免在 lastRound 恢复前清空状态
        if (oldValue === undefined) {
            if (value[0]) {
                coefficients.value.round.step = 0;
                game.value.tower.fast = true;
            } else {
                game.value.tower.fast = false;
                coefficients.value.round.step = -1;
            }
            return;
        }
        if (value[0] === oldValue[0] && value[1] === oldValue[1]) return;
        reset();
        // console.log('自动模式+当前币种：', game.value.tower.auto.default, settingStore.pickedCurrency);
        if (value[0] || value[1]) {
            coefficients.value.round.step = 0;
            coefficients.value.round.level = 0;
            coefficients.value.round.prediction = [];
            coefficients.value.fields = [];
            coefficients.value.savedPredictions = [];
            coefficients.value.round.status = GameStatus.EMPTY;
            game.value.tower.fast = true;
        }
        // ↓切到手工模式 
        if (!value[0]) {
            game.value.tower.fast = false;
            coefficients.value.round.step = -1; 
        }
    },
    { immediate: true },
);

// ↓ 关闭于 2025.03.10 14:40:36 星期一  
// watch(
//     () => joinStateStore.gameRunning,
//     (value) => {
//         if (!value) {
//             setTimeout(() => {
//                 coefficients.value.round.level = 0;
//                 coefficients.value.fields = [];
//                 coefficients.value.round.prediction = [];
//                 coefficients.value.round.status = GameStatus.EMPTY;
//             }, 1000);
//         }
//     },
// );

// ↓ 用于在刷新后加载上局游戏 
watch(
    () => joinStateStore.lastRound,
    async (newVal) => {
        if (import.meta.server || !newVal || !Object.keys(newVal).length) {
            return;
        }
        if (newVal.hash == coefficients.value.round.hash){
            return; // 防止重复 
        }
        await Sleep(500); 
        skipModeReset.value = true;
        game.value.tower.auto.default = false; // 肯定是手动！ 
        joinStateStore.gameRunning = true;
        const roundsLen = newVal.rounds?.length ?? 0;
        const status = roundsLen ? GameStatus.CASHOUT : GameStatus.PLAY; 
        console.log('towerLastRound ↓\n', deepCopy(newVal));
        console.log('towerLastRound status =', status); 
        const lastRound = {
            ...coefficients.value.round,
            ...newVal,
            status,
            step: newVal.step ?? roundsLen,
            prediction: newVal.prediction ?? [],
        };
        if (newVal.amount != null) {
            oForm.amount = newVal.amount;
        }
        const coefficientsData = { ...coefficients.value };
        coefficientsData.fields = newVal.rounds ?? [];
        coefficientsData.numberDevilkins = newVal.difficulty ?? coefficientsData.numberDevilkins;
        coefficientsData.round = lastRound;
        coefficients.value = coefficientsData;
        await nextTick();
        skipModeReset.value = false;
        showLastRoundLoadedInfo();
    },
    { immediate: true, deep: true },
);

// ↓ 加载游戏配置信息 
watch(
    () => joinStateStore.hasGameInfoLoaded,
    async (newVal) => {
        if (!newVal || import.meta.server) {
            return;
        }
        const {coefficients} = joinStateStore.config;
        // console.log('GameInfoLoaded =', deepCopy(coefficients));
        Object.assign(mutiConfig, coefficients);
    },
    { immediate: true, deep: true },
);

let time01 = null;
// ↓ 提示用户“非理性” 投注金额（手动模式下很难触发）
watch([
    () => oForm.amount,
    () => coefficients.value.numberDevilkins,
    () => coefficients.value.fields,
    () => coefficients.value.savedPredictions,
    () => game.value.tower.auto.default,
], (newArr)=>{
    clearTimeout(time01);
    const val01 = coefficients.value.round.win;
    // // 需要延时，防止游戏终止(输)后仍然弹出提示 
    time01 = setTimeout(()=>{
        if (val01 && !coefficients.value.round.win){
            return; // 突然输了，不提示 
        }
        const ind = (
            game.value.tower.auto.default
            ? Math.max(0, coefficients.value.savedPredictions?.length - 1)
            : coefficients.value.fields?.length // 超长越界无妨，会因取不到倍数而自然终止(reutrn) 
        );
        const aMulti = mutiConfig[coefficients.value.numberDevilkins];
        const expectingMulti = aMulti[ind]; 
        if (!expectingMulti) return;
        const expectingReward = oForm.amount * expectingMulti;
        console.log('期待赔付倍数与金额：', expectingMulti + '倍__', expectingReward.toLocaleString()); 
        showTips4BadAmountIfNeeded(expectingReward);
    }, 500);
});

onMounted(() => {
    if (coefficients.value.round.hash){
        return; // 已经加载上局的 step 值，终止下方的 step 赋值 
    }
    // -- 自动模式起始行是 0 
    const step = game.value.tower.auto.default ? 0 : -1;
    coefficients.value.round.step = step;  
});

onUnmounted(() => {
    musicControler?.toDestory();
});
</script>

<style lang="scss" scoped>
.tower-game {
    @media (max-width: 768px) {
        padding: 4px 0;
    }
}
.tower-container {
    background-color: rgb(27, 26, 111); 
    background-image: url('./img/tower_bg.webp');
    background-size: 100% 100%;
    border-radius: 10px;
    margin-bottom: 24px;
    padding: 20px 20px 20px 220px;

    @media (max-width: 576px) {
        background: url('./img/bg-mobile.webp');
        background-repeat: no-repeat;
        background-size: cover;
        padding: 16px 12px;
        margin: 0 -12px;
    }
}
</style>
